import useMutationApi from 'src/api/useMutationApi';

export interface GlJournalHeader {
  description?: string;
  journalGroup: string;
  accessGroup?: string;
  accrualFlag: 'Y' | 'N';
  cashFlag: 'Y' | 'N';
}

export interface GlJournalLine {
  costCenterId?: string;
  phaseId?: string;
  departmentId?: string;
  accountId?: string;
  postingDate: string;
  description?: string;
  hours?: string | number | null;
  quantity?: string | number | null;
  debit: string | number;
  credit: string | number;
}

export interface TestGlJournalImportInput {
  header: GlJournalHeader;
  lines: GlJournalLine[];
  importFilename?: string;
  dryRun?: boolean;
}

export interface TestGlJournalImportResult {
  success: boolean;
  dryRun: boolean;
  importFilename?: string;
  errorFilename?: string;
  errorFileContent?: string;
  totalDebit: string;
  totalCredit: string;
  payload: string;
  message: string;
}

const useTestGlJournalImport = (onSuccess?: () => void) => {
  return useMutationApi<TestGlJournalImportInput, TestGlJournalImportResult>({
    endpoint: 'famous/gl-journal/test-import',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useTestGlJournalImport;
